import {appCall, appSetObj, appSetVal, completeSession} from "../../../../store/application";
import {getData} from '../models/transaction';
import {changeStep} from "../../../../layouts/Content/modules/step";
import {STEPS} from '../../../../constants'
import {setLoadingContent} from "../../../../layouts/Content/modules/loadingContent";

import MAYA from '../../../../maya_api'
import {getSocket} from "../../../../sockets";

// ------------------------------------
// Actions
// ------------------------------------


function updateAmounts() {
  return (dispatch, getStore) => {
    dispatch(appCall('updateAmounts'))
  }
}


function submitTransaction(extraModel = null){
  return async(dispatch, getStore) => {
    dispatch(setLoadingContent(true));
    dispatch(appSetVal('init_payment_done', false));

    const sessionData = getData(getStore, extraModel);
    if(!sessionData) return fail();

    await dispatch(appSetObj(sessionData, true));

    let result = null;

    result = await dispatch(appCall('doPrevalins'));
    if(!(result && result.prevalins_status)) return fail();

    result = await dispatch(appCall('initPayment'));

    if(!result) return fail();

    return success();

    function success() {
      dispatch(setLoadingContent(false));
      dispatch(appSetVal('init_payment_success', true));
      dispatch(completeSession());
      return dispatch(changeStep(STEPS.SHOPPING_CART));
    }

    function fail() {
      dispatch(setLoadingContent(false));
      dispatch(appSetVal('init_payment_done', true));
      dispatch(appSetVal('init_payment_success', false));
      return false;
    }
  };
}

function checkBalance() {
  return async(dispatch, getStore) => {
    dispatch(appCall('checkBalance'))
  }
}

function resetCardOperations() {
  return async(dispatch, getStore) => {
    dispatch(appSetObj({
      prevalins_done: false,
      prevalins_status: false,
      prevalins_response_text: '',
      check_balance_done: false,
      check_balance_status: false,
      check_balance_response_text: '',
      balance_amount: 0
    }))
  }
}

function updateCardData() {
  return async(dispatch, getStore) => {
    const scannerData = getStore().scanner;

    await dispatch(appSetVal('card_track1', scannerData.cardTrack1, true));
    await dispatch(appSetVal('card_track2', scannerData.cardTrack2, true));
    await dispatch(appSetVal('card_parsed_account', scannerData.cardAccountNumber, true));
  }
}

export {
  updateCardData,
  updateAmounts,
  submitTransaction,
  checkBalance,
  resetCardOperations
};



// WEBPACK FOOTER //
// ./src/components/Applications/CashReload/modules/cashreload.js